import { render, staticRenderFns } from "./host.vue?vue&type=template&id=0365728a&scoped=true"
import script from "./host.vue?vue&type=script&lang=js"
export * from "./host.vue?vue&type=script&lang=js"
import style0 from "./host.vue?vue&type=style&index=0&id=0365728a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365728a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreView: require('/app/components/core/View.vue').default})
